<template>
  <div class="item-list-wrapper">
    <div class="top-title">
      <img src="../images/yj_item_top_decoration.png">
      <span class="title">{{ title }}</span>
      <img src="../images/yj_item_top_decoration.png">
    </div>
    <div class="container-box">
      <ul class="item-container container-1">
        <li class="item" v-for="(item, index) in itemList1" :key="index" >
          <div @click.stop="gotoItemDetail(item, index)" class="item-box GOODITEM" :data-id="item.itemId">
            <div class="item-img-box">
              <img class="item-img" :src="item.itemImg">
              <!-- <img class="hot-sell" src="../images/yj_hot_sell.png"> -->
            </div>
            <p class="item-title">{{ item.itemName || ''}}</p>
            <div class="tag-box" v-if="labelList1[index] && labelList1[index].itemLabelMarkingResponses && labelList1[index].itemLabelMarkingResponses.length">
              <span :class="{'tag': true, 'type-2': label.type === 2}" v-for="(label, index) in labelList1[index].itemLabelMarkingResponses" :key="index">{{label.text}}</span>
            </div>
            <p class="original-price">原价¥{{item.itemVipPrice || 0}}</p>
            <div class="item-bottom">
              <div class="bottom-left">
                <!-- <p class="item-tag">{{ itemTag }}</p> -->
                <p class="price">¥{{ item.itemPrice }}</p>
                <p class="earn" v-if="!isVip">赚{{item.minCommission}}</p>
              </div>
              <!-- <img class="shoping-cart" src="../images/yj_shoping_cart.png"> -->
            </div>
          </div>
          <wx-open-launch-weapp
              class="item-list-wx-open-launch-weapp"
              :username="getWxAppId"
              :path="weappPath(item)"
              @launch="handleLaunchFn(item, index)"
              @error="handleErrorFn(item)"
              v-if="wxOpenLaunchWeappTagIsValid && +appCont !== 7"
            >
              <script type="text/wxtag-template">
                <style>.btn {  opacity: 0;width: 342px; height: 400px; display: block; border-radius: 0px;}</style>
                <button class="btn">打开小程序</button>
              </script>
            </wx-open-launch-weapp>
        </li>
      </ul>
      <ul class="item-container">
        <li class="item" v-for="(item, index) in itemList2" :key="index" >
          <div @click.stop="gotoItemDetail(item, index)" class="item-box GOODITEM" :data-id="item.itemId">
            <div class="item-img-box">
              <img class="item-img" :src="item.itemImg">
              <!-- <img class="hot-sell" src="../images/yj_hot_sell.png"> -->
            </div>
            <p class="item-title">{{ item.itemName || ''}}</p>
            <div class="tag-box" v-if="labelList2[index] && labelList2[index].itemLabelMarkingResponses">
              <span :class="{'tag': true, 'type-2': label.type === 2}" v-for="(label, index) in labelList2[index].itemLabelMarkingResponses" :key="index">{{label.text}}</span>
            </div>
            <p class="original-price">原价¥{{item.itemVipPrice || 0}}</p>
            <div class="item-bottom">
              <div class="bottom-left">
                <!-- <p class="item-tag">{{ itemTag }}</p> -->
                <p class="price">¥{{ item.itemPrice }}</p>
                <p class="earn" v-if="!isVip">赚{{item.minCommission}}</p>
              </div>
              <!-- <img class="shoping-cart" src="../images/yj_shoping_cart.png"> -->
            </div>
          </div>
          <wx-open-launch-weapp
              class="item-list-wx-open-launch-weapp"
              :username="getWxAppId"
              :path="weappPath(item)"
              @launch="handleLaunchFn(item, index)"
              @error="handleErrorFn(item)"
              v-if="wxOpenLaunchWeappTagIsValid && +appCont !== 7"
            >
              <script type="text/wxtag-template">
                <style>.btn {  opacity: 0;width: 342px; height: 400px; display: block; border-radius: 0px;}</style>
                <button class="btn">打开小程序</button>
              </script>
            </wx-open-launch-weapp>
        </li>
      </ul>      
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import wxConstData from '@/common/define/wxConstData'
import { wxOpenLaunchWeappTagIsValid, getWxAppOriginId } from '../../../common/utils/wxUtil.js'
import { exposureThinkingReport } from '../../../common/js/Util'
import {
  memberType
} from '../api/home'

export default {
  name: 'itemList',
  props: {
    labelList1: {
      type: Array,
      default() {
        return []
      }
    },
    labelList2: {
      type: Array,
      default() {
        return []
      }
    },
    itemList1: {
      type: Array,
      default() {
        return []
      }
    },
    itemList2: {
      type: Array,
      default() {
        return []
      }
    },
    isCouponReward: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isVip: true
    }
  },
  computed: {
    ...mapGetters(['shopId', 'luckBagCode', 'smsId', 'appCont']),
    title() {
      if (this.isCouponReward) {
        return '以下商品用券超实惠'
      }
      return '看看爆款好物，超值特卖中'
    },
    itemTag() {
      if (this.isCouponReward) {
        return '特卖价'
        // return '券后价'
      }
      return '特卖价'
    },
    /**
     * 获取微信小程序原始id
     */
    getWxAppId() {
      return wxConstData.yunjiWXAppOriginId
    },
    /**
     * 跳转小程序按钮是否有效
     */
    wxOpenLaunchWeappTagIsValid() {
      return wxOpenLaunchWeappTagIsValid()
    }
  },
  mounted() {
    this.getUserTypeInfo()
  },
  methods: {
    beforeunloadFn() {
      // localStorage.setItem('ceshiceshi', '11111')
      const ids = exposureThinkingReport()
      window.thinkingReport.track('exposure', {
        page_id: '81023',
        point_id: '29038',
        item_id: ids.join(','),
        content_name: +this.appCont === 7 ? '小程序' : 'h5',
        point_name: '离开曝光'
      })
      console.log({
        page_id: '80612',
        point_id: '26436',
        content_type: '内容类型',
        item_id: ids.join(','),
        point_name: '离开曝光'
      })
    },
    getUserTypeInfo() {
      memberType({
        appCont: this.appCont
      }).then((res) => {
        this.isVip = +res.data !== 1
      })
    },
    weappPath(item) {
      return `pages/detail/detail.html?itemId=${item.itemId}`
    },
    handleErrorFn(e) {
      console.log('跳转小程序组件跳转失败 fail', e.detail)
      // this.gotoItemDetail()
      // this.canUseWeapp = false
      // eslint-disable-next-line no-unused-expressions
      // document.getElementById('launchBox') && document.getElementById('launchBox').remove()
    },
    handleLaunchFn(item, index) {
      thinkingReport.track('click_list', {
        point_id: '29036',
        page_id: '81023',
        item_id: item.itemId || 0,
        content_name: +this.appCont === 7 ? '小程序' : 'h5',
        index: index,
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      this.beforeunloadFn()
      console.log('跳转小程序组件跳转成功  success')
      // eslint-disable-next-line no-unused-expressions
      // document.getElementById('launchBox') && document.getElementById('launchBox').remove()
    },
    gotoItemDetail(item, index = 0) {
      thinkingReport.track('click_list', {
        point_id: '29036',
        page_id: '81023',
        item_id: item.itemId || 0,
        content_name: +this.appCont === 7 ? '小程序' : 'h5',
        index: index,
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      this.beforeunloadFn()
      if (+this.appCont === 7) {
        wx.miniProgram.navigateTo({ url: `/pages/detail/detail?itemId=${item.itemId}&shopId=${this.shopId}` })
        return
      }
      const { hostname } = window.location
      const y = hostname.split('.')[0]
      const userPath = y === 'spe' ? 'm.yunjiglobal.com' : 't-do-dev.yunjiglobal.com' // 拉起app的现网域名就是m.yunjiglobal.com
      window.location.href = `${window.location.protocol}//${userPath}/yjbuyer/seller-link?shopId=${this.shopId}&goType=productDetail&itemId=${item.itemId}`
    }
  }
}
</script>
<style>
.item{
  position: relative;
}
.item-list-wx-open-launch-weapp {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
</style>
<style lang="less" scoped>
.item-list-wrapper {
  margin-top: 0.2rem;
  padding-bottom: .8rem;
  width: 100%;
  .top-title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: 0.34rem;
    }
    .title {
      margin: 0 0.2rem;
      color: #fff;
      font-size: 0.32rem;
      line-height: 0.4rem;
      height: 0.4rem;
      font-weight: bold;
    }
  }
  .container-box {
    display: flex;
    justify-content: center;
  }
  .item-container {
    padding: 0.4rem 0;
    padding-bottom: 1rem;
    // padding-right: 0;
    // display: flex;
    // justify-content: space-between;
    // flex-wrap: wrap;
    column-count: 1;
    column-gap: 0.18rem;
    &.container-1 {
      margin-right: 0.18rem;
    }
    .item {
      break-inside: avoid;
      box-sizing: border-box;
      padding-bottom: 0.18rem;
      .item-box {
        // padding: 10px;
        width: 3.42rem;
        // height: 4.9rem;
        // margin-bottom: 0.2rem;
        background-color: #fff;
        border-radius: 0.12rem;
        overflow: hidden;
        padding-bottom: 0.32rem;
        height: 100%;
        overflow: auto;
        .item-img-box {
          width: 3.42rem;
          height: 3.42rem;
          overflow: hidden;
          position: relative;
          .item-img {
            display: block;
            width: 100%;
            object-fit: cover;
          }
          .hot-sell {
            position: absolute;
            left: 0.24rem;
            bottom: 0;
            width: 0.88rem;
          }
        }
        .item-title {
          margin: 0.2rem 0.2rem 0.08rem 0.2rem;
          // font-size: 0.3rem;
          max-height: 0.72rem;
          // line-height: 0.36rem;
          // font-weight: bold;
          color: #262626;
          overflow:hidden;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2;

          font-family: PingFangSC-Regular;
          font-size: 0.28rem;
          color: #111111;
          // line-height: 0.36rem;
    
        }
        .original-price {
          font-family: PingFangSC-Regular;
          font-size: 0.24rem;
          color: #AAAAAA;
          line-height: 0.32rem;
          // padding: 0 0.2rem;
          margin-left: 0.2rem;
          position: relative;
          width: max-content;
          margin-bottom: 0.12rem;
          &::after {
            content: '';
            display: inline-block;
            width: 100%;
            height: 0.02rem;
            background: #AAAAAA;
            position: absolute;
            left: 0;
            top: 0.14rem
          }
        }
        .tag-box {
          height: 0.36rem;
          padding: 0 10px;
          margin-bottom: 0.32rem;
          overflow: hidden;
          // white-space:nowrap;
          width: 3.34rem;
          .tag {
            height: 0.32rem;
            background: #fff;
            color: #FF2735;
            border-radius: 0.04rem;
            padding: 0 0.12rem;
            font-family: PingFangSC-Medium;
            font-size: 0.18rem;
            line-height: 0.32rem;     
            margin-right: 0.06rem;    
            border: 0.02rem solid #FF2735; 
            vertical-align: middle;
            display: inline-block;
            &.type-2 {
              font-size: 0.22rem;
              height: 0.32rem;
              background: #F10D3B;
              border: none;
              color: #fff;
            }
          }

        }
        .item-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 0.24rem;
          .bottom-left {
            display: flex;
            align-items: center;
            .item-tag {
              background-color: #EE2532;
              padding: 0 0.1rem;
              color: #fff;
              font-size: 0.18rem;
              border-radius: 0.16rem;
              height: 0.32rem;
              line-height: 0.32rem;
              vertical-align: middle;
            }
            .price {
              // margin-left: 0.12rem;
              font-family: PingFangSC-Medium;
              font-size: 0.32rem;
              color: #111111;
              line-height: 0.36rem;
            }
            .earn {
              font-family: PingFangSC-Regular;
              font-size: 0.26rem;
              color: #FF2735;
              line-height: 0.32rem;
              margin-left: 0.12rem;
            }
          }
          .shoping-cart {
            display: block;
            width: 0.4rem;
          }
        }        
      }

    }
  }
}
</style>
